import { Card, CardContent, Link, Tag, Typography } from '@volvo/vcdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

const CampaignTypes: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <Typography variant="heading4" className="mb-9">
          {t(($) => $.components.campaign_types.title)}
        </Typography>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
          <div className="flex flex-col gap-5">
            <Tag variant="error-subtle">{t(($) => $.components.campaign_types.recall.title)}</Tag>
            <Typography>{t(($) => $.components.campaign_types.recall.description)}</Typography>
          </div>
          <div className="flex flex-col gap-5">
            <Tag variant="warning-subtle">{t(($) => $.components.campaign_types.quality.title)}</Tag>
            <Typography>{t(($) => $.components.campaign_types.quality.description)}</Typography>
          </div>
          <div className="flex flex-col gap-5">
            <Tag variant="neutral-subtle">{t(($) => $.components.campaign_types.service.title)}</Tag>
            <Typography>{t(($) => $.components.campaign_types.service.description)}</Typography>
          </div>
          <div className="flex flex-col gap-5">
            <Tag variant="info-subtle">{t(($) => $.components.campaign_types.installation.title)}</Tag>
            <Typography>{t(($) => $.components.campaign_types.installation.description)}</Typography>
            <div className="flex flex-col gap-2">
              <Typography>
                <Link
                  variant="inline-discreet"
                  href="https://apps.apple.com/se/app/volvo-penta-connect/id6469306435"
                  target="_blank"
                >
                  {t(($) => $.components.campaign_types.installation.app_store)}
                </Link>
              </Typography>
              <Typography>
                <Link
                  variant="inline-discreet"
                  href="https://play.google.com/store/apps/details?id=com.volvopenta.pentaconnect"
                  target="_blank"
                >
                  {t(($) => $.components.campaign_types.installation.google_play)}
                </Link>
              </Typography>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default withComponentErrorBoundary(CampaignTypes);
